import { useQuery } from '@tanstack/react-query';
import { api, type ApiSuccess } from '../lib/api';

interface StaffMember {
  id: string;
  name: string;
  email: string;
  role: 'ADMIN' | 'SUPER_ADMIN';
  userNumber: number;
}

interface StaffSelectProps {
  value: string;
  onChange: (id: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
}

/**
 * 👮 قائمة منسدلة لاختيار أحد موظفي الإدارة (Admin / Super Admin)
 * تُستخدم في الإسناد (شكاوى، مرافق، طلبات، رسائل...)
 */
export function StaffSelect({
  value,
  onChange,
  label = 'إسناد إلى',
  placeholder = '— بدون إسناد —',
  required = false,
  className = '',
}: StaffSelectProps) {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'staff'],
    queryFn: () => api.get<ApiSuccess<StaffMember[]>>('/api/admin/users/staff'),
    staleTime: 5 * 60 * 1000, // 5 دقائق
  });

  const staff = data?.data ?? [];

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-bold text-ink mb-1">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={isLoading}
        className="w-full px-4 py-2.5 rounded-xl border-2 border-gray-200 focus:border-navy outline-none bg-white text-sm disabled:bg-gray-50"
      >
        <option value="">{isLoading ? '⟳ جاري التحميل…' : placeholder}</option>
        {staff.map((u) => (
          <option key={u.id} value={u.id}>
            #{u.userNumber} — {u.name} ({u.role === 'SUPER_ADMIN' ? 'سوبر أدمن' : 'أدمن'})
          </option>
        ))}
      </select>
    </div>
  );
}
